import axios from 'axios';
import { API_BASE_URL } from '@/config';

export class BusinessUnitsApi {
  static getBusinessUnits = async (facilityId) => {
    return (
      await axios.get(
        API_BASE_URL +
          '/business-units' +
          `${facilityId ? `?facilityId=${facilityId}` : ''}`,
      )
    ).data;
  };

  static getBusinessUnitsForForm = async (facilityId) => {
    return (
      await axios.get(
        API_BASE_URL +
          '/business-units/for-forms' +
          `${facilityId ? `?facilityId=${facilityId}` : ''}`,
      )
    ).data;
  };

  static getBusinessUnit = async (id) => {
    return (await axios.get(API_BASE_URL + '/business-units/' + id)).data;
  };

  static createBusinessUnit = (formData) => {
    return axios.post(API_BASE_URL + '/business-units', formData);
  };

  static updateBusinessUnit = (id, formData) => {
    return axios.put(API_BASE_URL + '/business-units/' + id, formData);
  };

  static deleteBusinessUnit = (id) => {
    return axios.delete(API_BASE_URL + '/business-units/' + id);
  };
}
